"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CcpRequest = void 0;
const enumify_1 = require("enumify");
class CcpRequest extends enumify_1.Enumify {
    constructor({ role, resourceAri, defaultCurrency, annualCycle }) {
        super();
        this.role = role;
        this.resourceAri = resourceAri;
        this.defaultCurrency = defaultCurrency;
        this.annualCycle = annualCycle;
    }
}
exports.CcpRequest = CcpRequest;
CcpRequest.TRANSACTION_ACCOUNT = new CcpRequest({
    role: 'transaction-account/billing-admin',
    resourceAri: 'ari:cloud:commerce::transaction-account/',
    defaultCurrency: 'USD',
    annualCycle: 'ANNUAL',
});
CcpRequest.ENTITLEMENT_ECC = new CcpRequest({
    role: 'end-customer-contact',
    resourceAri: 'ari:cloud:commerce::entitlement/',
});
CcpRequest._ = CcpRequest.closeEnum();
